import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import deepmerge from 'deepmerge';
// @ts-ignore
import uiWebTranslations from 'fulogics-ui-web/dist/translations/locales/pl.json';

import { translations } from './index';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
    resources: deepmerge(translations, uiWebTranslations),
    lng: 'pl',
    react: {
        useSuspense: false
    }
});

export default i18n;